module.exports = __webpack_public_path__ + "img/pala_negra_padel.5e858158.jpg";